import React from "react";
import _ from "underscore";
import Dropdown from "../atoms/atom-drop-down-select-option.jsx";
import PropTypes from "prop-types";

class SizeDropdown extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    primaryValue: PropTypes.string,
    selectorName: PropTypes.string.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.setState({
      options: this.dropdownValues(this.props),
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      options: this.dropdownValues(nextProps),
    });
  }

  dropdownValues(props) {
    const { skus, availabilityKey } = props;
    let options = _.indexBy(skus, "id");
    options = _.mapObject(options, sku => {
      const avail = _.first(sku[availabilityKey]);
      const { count } = avail;
      const canonical = sku.canonicalSizes.join("-");
      const specialSize = sku.size.indexOf(canonical) === -1;
      const sizeString = specialSize ? sku.size + " / " + canonical : sku.size;
      return count > 0 ? sizeString : sizeString + " - Unavailable";
    });
    return options;
  }

  disableRule(options) {
    return options.indexOf("Unavailable") !== -1;
  }

  render() {
    //TODO support more than one size
    const { primaryValue, selectorName, onChange } = this.props;
    const options = this.state.options || {};

    return (
      <div className="size-dropdown">
        <Dropdown
          selectorName={selectorName}
          selectedOption={primaryValue}
          dropdownValues={options}
          onChange={onChange}
          placeholderOption={"Select Size"}
          disableRule={this.disableRule}
        />
      </div>
    );
  }
}

export default SizeDropdown;
